import { MembersAreaScreen } from '@features/members-area'

export function AreaMembrosPage() {
  return <MembersAreaScreen />
}
